/**
 * @module M/plugin/Maritimesignals
 */
import '../assets/css/maritimesignals';
import MaritimeSignalsControl from './maritimesignalscontrol';
import { getValue } from './i18n/language';

/**
 * @classdesc
 * Main facade plugin object. This class creates a plugin
 * object which has an implementation Object
 */
export default class MaritimeSignals extends M.Plugin {
  /**
   * @constructor
   * @extends {M.Plugin}
   * @param {Object} impl implementation object
   * @api stable
   */
  constructor(options) {
    super();

    /**
     * Controls of the plugin
     *
     * @private
     * @type {array<M.Control>}
     */
    this.controls_ = [];

    /**
     * Position of the plugin
     *
     * @private
     * @type {string} - TL | TR | BL | BR
     */
    this.position_ = options.position || 'TL';

    if (this.position_ === 'TL' || this.position_ === 'BL') {
      this.positionClass_ = 'left';
    }

    /**
     * Plugin tooltip
     *
     * @private
     * @type {string}
     */
    this.tooltip_ = options.tooltip || getValue('tooltip');

    /**
     * URL
     *
     * @private
     * @type {string}
     */
    this.url_ = options.url;

    /**
     * Search fields
     *
     * @private
     * @type {Array}
     */
    this.searchFields_ = options.searchFields;

    /**
     * URL - Images
     *
     * @private
     * @type {String}
     */
    this.urlImages_ = options.urlImages;

    /**
     * Extension - Images
     *
     * @private
     * @type {String}
     */
    this.extensionImages_ = options.extensionImages;

    /**
     * Name default image
     *
     * @private
     * @type {String}
     */
    this.nameDefaultImage_ = options.nameDefaultImage;

    /**
     * Codes
     *
     * @private
     * @type {String}
     */
    this.codesImages_ = options.codesImages;

    /**
     * Codes Nie
     *
     * @private
     * @type {String}
     */
    this.codesNie_ = options.codesNie;


    /**
     * Left codes
     *
     * @private
     * @type {String}
     */
    this.leftCodes_ = options.leftCodes;

    /**
     * Warning
     *
     * @private
     * @type {String}
     */
    this.warning_ = options.warning;

    /**
     * Codes status
     *
     * @private
     * @type {Array}
     */
    this.codesStatus_ = options.codesStatus;
  }

  /**
   * This function adds this plugin into the map
   *
   * @public
   * @function
   * @param {M.Map} map the map to add the plugin
   * @api
   */
  addTo(map) {
    this.facadeMap_ = map;
    this.control_ = new MaritimeSignalsControl({
      url: this.url_,
      searchFields: this.searchFields_,
      urlImages: this.urlImages_,
      extensionImages: this.extensionImages_,
      nameDefaultImage: this.nameDefaultImage_,
      codesImages: this.codesImages_,
      leftCodes: this.leftCodes_,
      warning: this.warning_,
      codesStatus: this.codesStatus_,
      codesNie: this.codesNie_,
    });
    this.panel_ = new M.ui.Panel('M.plugin.maritimesignals.NAME', {
      collapsible: true,
      className: `m-maritimesignals ${this.positionClass_}`,
      collapsedButtonClass: 'm-maritimesignals-lighthouse',
      position: M.ui.position[this.position_],
      tooltip: this.tooltip_,
    });
    this.controls_.push(this.control_);
    this.panel_.addControls(this.controls_);
    map.addPanels(this.panel_);
  }

  /**
   * This function destroys this plugin
   *
   * @public
   * @function
   * @api
   */
  destroy() {
    this.facadeMap_.removeControls([this.control_]);
    [this.facadeMap_, this.control_, this.panel_] = [null, null, null];
  }

  /**
   * Name of the plugin
   *
   * @public
   * @function
   * @api
   */
  get name() {
    return 'maritimesignals';
  }

  /**
   * This function returns the position
   *
   * @public
   * @return {string}
   * @api
   */
  get position() {
    return this.position_;
  }

  /**
   * Get the API REST Parameters of the plugin
   *
   * @function
   * @public
   * @api
   */
  getAPIRest() {
    return `${this.name}=${this.position}`;
  }
}
